import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Card,
  CardImg,
} from 'reactstrap';

const Poster = (props) => {
  
  const plakat =  props.data.content;
  return (
    <div className="col-md-4" style={{paddingBottom: '30px'}}>
      <Card inverse style={{ height: '320px', width: '216px', margin: 'auto'}} className={props.data.allapot.name === "INAKTIV" ? "poster-inactive" : ""}>
        <CardImg src={"data:image/bmp;base64," + plakat} alt="Card image cap"/>
        <div className="poster-bg" />
        <div className="poster-content">{props.data.eredeti}</div>
        <div className="poster-overlay">
          <div className="poster-button-group">
            <Button color="link" block size="lg" className="poster-button" onClick={e => props.onViewClick(props.data.id)}> 
              <i className="fa fa-eye" aria-hidden="true" />
            </Button> 
            <Button color="link" block size="lg" className="poster-button" onClick={e => props.onEditClick(props.data.id)}>
              <i className="fa fa-pencil" aria-hidden="true" />
            </Button>
            <Button color="link" block size="lg" className="poster-button" onClick={e => props.onDeleteClick(props.data.id)}>
              <i className="fa fa-trash-o" aria-hidden="true" />
            </Button> 
          </div>
        </div>
      </Card>
    </div>
  );
};

Poster.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Poster;
